module.exports = __webpack_public_path__ + "static/media/features-split-top-02.6bc0b27b.png";